<template>
  <div class="sever">
    <div class="content_banner">
      <img src="../../assets/img/banner/banner_server.jpg" alt="">
    </div>

    <div class="container_wrap">
      <el-row :gutter="30">
        <el-col :span="5">
          <div class="side_hd">
            <h2>服务领域</h2>
            <p>RANGE OF SERVICES</p>
          </div>
          <div class="side_wrap">
            <ul>
              <li v-for="(item,index) in sideNav" :class="{'active' : cur == item.id}" :key="index" @click="sideNavActice(item,index)">
                <a href="javascript:;">{{item.title}}</a>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="contTit">
            <h2>服务内容</h2>
          </div>
          <div class="contRWrap" style="padding: 10px;" v-html="content"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news',
  data(){
    return{
      cur: 0,
      sideNav: [],
      id: '',
      content: ''

    }
  },
  mounted: function(){

  },
  created: function(){
    var _this = this
    _this.getSeverNav();
    var urlId = _this.$router.history.current.query.id;
    _this.cur = urlId;
    _this.getDetail(urlId);
  },
  methods: {
    // 侧导航
    sideNavActice(item,index){
      console.log('index :>> ', index);
      var _this = this
      _this.cur = item.id;
      _this.id = item.id;
      _this.getDetail(item.id)
    },
    async getSeverNav(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/serve/getServeList', { classification: 20000 });
      if(data.code == 200){
        _this.sideNav = data.data
      }
    },
    async getDetail(id){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getNewsDetail',{id: id});
      if(data.code == 200){
        _this.content = data.data.content
      }
    }
  },
  watch: {
    '$route': function () {
      var _this = this;
      _this.cur = _this.$router.history.current.query.id;
      _this.getDetail(_this.$router.history.current.query.id);
    }
  }
}
</script>